export const calcularCarenciaEfetivaMeses = vendas => {
  if (!vendas) return 0;
  const aData = valor => {
    if (!valor) return null;
    const data = new Date(valor);
    return isNaN(data.getTime()) ? null : data;
  };
  const mesesAlemDoNormal = (dataInicial, dataFinal) =>
    Math.max(
      0,
      (dataFinal.getFullYear() - dataInicial.getFullYear()) * 12 +
        dataFinal.getMonth() -
        dataInicial.getMonth() -
        1
    );

  const dataVenda = aData(vendas.dataVenda);
  if (!dataVenda) return 0;

  const financiamentos = (vendas && vendas.financiamentos) || {};
  let maiorCarencia = 0;
  Object.keys(financiamentos).forEach(codigoAtivo => {
    const parcelas =
      (financiamentos[codigoAtivo] &&
        financiamentos[codigoAtivo].parcelasFinanciamento) ||
      [];
    if (parcelas.length === 0) return;

    const parcelasDoParcelamento = parcelas.filter(
      parcela => !parcela.tipo_intermediaria && !parcela.periodicidade_balao
    );
    const lista =
      parcelasDoParcelamento.length > 0 ? parcelasDoParcelamento : parcelas;
    const datasFinanciamento = lista
      .map(parcela => aData(parcela && parcela.vencimento))
      .filter(data => data);
    if (datasFinanciamento.length === 0) return;

    const dataPrimeira = new Date(
      Math.min.apply(
        null,
        datasFinanciamento.map(data => data.getTime())
      )
    );
    const meses = mesesAlemDoNormal(dataVenda, dataPrimeira);
    if (meses > maiorCarencia) maiorCarencia = meses;
  });
  return maiorCarencia;
};
